module.exports = __webpack_public_path__ + "assets/img/img-premium-problem-01@2x.b57a365.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/premium/img-premium-problem-01@2x.png
// module id = 980
// module chunks = 1